// extracted by mini-css-extract-plugin
export default {"App":"App_App__bkGAb","app":"App_app__Pvbw6"};